import { render, staticRenderFns } from "./MergeParent.vue?vue&type=template&id=505fbca0"
import script from "./MergeParent.vue?vue&type=script&lang=js"
export * from "./MergeParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports